import 'jquery';
import 'popper.js';
import 'bootstrap/dist/js/bootstrap';
import '../static/major/scss/styles.scss';
import 'font-awesome/scss/font-awesome.scss';

import '../static/major/js/header';
import '../static/major/js/menu';
